import React from 'react';
import moment from 'moment';
import { Col, Typography, Row } from 'antd';
import { TitleSections } from '../../../components/TitleSections';
import { TextSectiosTabs } from '../../../components/TitleSections/styles';
import { Text } from '../../../components/Text';

export function DetalhesViagem({ detalhesViagem }) {
  return <>
    <TitleSections title="Detalhes da Viagem" />
    <TextSectiosTabs>
      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px', marginTop: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text title="Lote Tmov" value={detalhesViagem?.idLoteTmov} />
        </Col>
        <Col span={8}>
          <Text title="Origem" value={detalhesViagem?.origemViagem} />
        </Col>
        <Col span={8}>
          <Text title="Destino" value={detalhesViagem?.destinoViagem} />
        </Col>
      </Row>

      <Row
        gutter={[2, 8]}
        style={{ marginBottom: '16px' }}
        justify="space-between"
      >
        <Col span={8}>
          <Text title="Produto" value={detalhesViagem?.produto} />
        </Col>
        <Col span={8}>
          <Text title="Filial" value={detalhesViagem?.nomeFilial} />
        </Col>
        <Col span={8}>
          <Text
            title="Usuário responsável"
            value={detalhesViagem?.nomeUsuario}
          />
        </Col>
      </Row>
    </TextSectiosTabs>
         </>;
}
